import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import QRSignoff from "@/pages/QRSignoff";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import CreateProject from "@/pages/CreateProject";
import ProjectDetail from "@/pages/ProjectDetail";
import InstallationDetail from "@/pages/InstallationDetail";
import ReviewQueue from "@/pages/ReviewQueue";
import Customers from "@/pages/Customers";
import UsersPage from "@/pages/Users";
import RolesPermissions from "@/pages/RolesPermissions";
import Forms from "@/pages/Forms";
import AuditLogs from "@/pages/AuditLogs";
import Settings from "@/pages/Settings";
import Profile from "@/pages/Profile";

const wrap = (el) => (
  <ProtectedRoute>
    <AppLayout>{el}</AppLayout>
  </ProtectedRoute>
);

const wrapRoles = (el, roles) => (
  <ProtectedRoute roles={roles}>
    <AppLayout>{el}</AppLayout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify/qr/:token" element={<QRSignoff />} />

            <Route path="/dashboard" element={wrap(<Dashboard />)} />
            <Route path="/projects" element={wrap(<Projects />)} />
            <Route path="/projects/new" element={wrapRoles(<CreateProject />, ["project_manager", "super_admin"])} />
            <Route path="/projects/:id" element={wrap(<ProjectDetail />)} />
            <Route path="/installations/:id" element={wrap(<InstallationDetail />)} />
            <Route path="/review" element={wrapRoles(<ReviewQueue />, ["supervisor", "super_admin", "admin", "project_manager"])} />
            <Route path="/customers" element={wrapRoles(<Customers />, ["project_manager", "admin", "super_admin"])} />
            <Route path="/users" element={wrapRoles(<UsersPage />, ["admin", "super_admin"])} />
            <Route path="/permissions" element={wrapRoles(<RolesPermissions />, ["super_admin"])} />
            <Route path="/forms" element={wrapRoles(<Forms />, ["super_admin"])} />
            <Route path="/audit" element={wrapRoles(<AuditLogs />, ["super_admin"])} />
            <Route path="/settings" element={wrapRoles(<Settings />, ["super_admin"])} />
            <Route path="/profile" element={wrap(<Profile />)} />

            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
